import * as uiLib from '@compliance.ai/web-components';

export const SELECT_ACTION_NAMES = {
  INPUT_CHANGE: uiLib.SELECT_INPUT_CHANGE_ACTIONS.INPUT_CHANGE
};
